import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import apifunctions from '../../components/Tienda/api/functions.js';

import './profesionales.scss';

import {InputLabeled, InputComponent, AlertMensaje} from './Inputs';

import {apiprofesionales} from './Profesionales'

const defaultStateForm = {
	nombre : '',
	categoria_id: '',
	email : '',
	direccion : '',
	telefono : '',
	telefono_2 : '',
	telefono_3 : '',
	ciudad : '',
	provincia : '',
	comentario : '',
	errors:{}
}

const AltaProfesionalesForm = (props) => {

	let envioTimeout = 0;

    const history = useHistory();

	/* 0 - Sin ENVIAR; 1 - Enviando; 2 - Exito; 3 - Fallo; */
	const [envioState, updateEnvioState] = useState(0);

	const [formState, updateState] = useState(defaultStateForm);

    const {categorias} = props;

	const updateFormState = (prop, val) =>{
		let newErrors = {...formState['errors']}
		if(newErrors[prop]){
			delete newErrors[prop];
		}  
		updateState({ ...formState, [prop]:val, 'errors': newErrors});
	}


	const setErrors = (errors) => {
		updateState({ ...formState, ['errors']:errors,});
	}

	const getError = (field) => {
		let errors = formState['errors'];
        if (errors && errors[field] && errors[field].length > 0) 
			return errors[field][0].detail;
        else return null;
    }

	const enviarEnabled = () => {
		let errors = formState['errors'];
		return errors && Object.keys(errors).length === 0
	}

	const SendMail = () => {

		const successCallback = (resp) => {
			clearTimeout(envioTimeout);
			envioTimeout = setTimeout(()=>updateEnvioState(0), 2500);
			updateEnvioState(2);
		}

		const errorCallback = (data) => {
			if(data && data.errors){
				setErrors(data.errors);
			}
		};

		const failureCallback = () => {
			clearTimeout(envioTimeout);
			envioTimeout = setTimeout(()=>updateEnvioState(0), 2500);
			updateEnvioState(3);
		};

		clearTimeout(envioTimeout);
		envioTimeout = setTimeout(()=>updateEnvioState(0), 2500);
		updateEnvioState(1);
		apifunctions.post(apiprofesionales.profesionales, null, formState, successCallback, errorCallback, failureCallback);
			
	}

	return (
        <section>
            <div className="container">
                <div className="row">
                    <div className="col-sm-8 offset-sm-2">
                        <div className="text-center">
							<h3>Inscripción de profesional</h3>
						</div>
                        <p className="ml-1">Complete sus datos para solicitar su incorporación a nuestro sitio.</p> 
                        <form id="profesionalesForm" onSubmit={()=>(false)} >
                            <InputLabeled
                                type={"text"} 
                                placeholder={"Nombre y Apellido"}
                                name={"nombre"}
                                className="form-control"
                                onChange={(evt)=>updateFormState("nombre", evt.target.value)}
                                error = {getError("nombre")}
                            />
                            <InputComponent
                                error = {getError("categoria_id") ? "Seleccione una Categoría" : " "}
                                component=
                                    {<select name="categoria_id"
                                        className={"form-control " + (getError("categoria_id") ? "is-invalid": "")} 
                                        onChange={(evt)=> updateFormState("categoria_id", evt.target.value)}
                                    >
                                        <option value="-1">Seleccione su profesión</option>
                                        {
                                            categorias.map( c => 
                                                <option value={c.id}>{c.nombre}</option>
                                            )
                                        }
                                    </select>}
                            />
                            <InputLabeled
                                type="text"
                                placeholder="Teléfono"
                                name="telefono"
                                className="form-control"
                                onChange={(evt)=>updateFormState("telefono", evt.target.value)}
                                error = {getError("telefono")}
                            />
                            <InputLabeled
                                type="text"
                                placeholder="Teléfono 2 (opcional)"
                                name="telefono_2"
                                className={"form-control"}
                                onChange={(evt)=>updateFormState("telefono_2", evt.target.value)}
                                error = {getError("telefono_2")}
                            />
                            <InputLabeled
                                type="text"
                                placeholder="Teléfono 3 (opcional)"
                                name="telefono_3"
                                className={"form-control"}
                                onChange={(evt)=>updateFormState("telefono_3", evt.target.value)}
                                error = {getError("telefono_3")}
                            />
                            <InputLabeled
                                type="email"
                                placeholder="Su e-mail"
                                name="email"
                                className={"form-control"}
                                onChange={(evt)=>updateFormState("email", evt.target.value)}
                                error = {getError("email")}
                            />
                            <InputLabeled
                                type="text"
                                placeholder="Su dirección"
                                name="direccion"
                                className="form-control"
                                onChange={(evt)=>updateFormState("direccion", evt.target.value)}
                                error = {getError("direccion")}
                            />
                            <div className="row">
                                <div className="col-sm-6">
                                    <InputLabeled
                                        type="text"
                                        placeholder="Ciudad"
                                        name="ciudad"
                                        className="form-control"
                                        onChange={(evt)=>updateFormState("ciudad", evt.target.value)}
                                        error = {getError("ciudad")}
                                    />
                                </div>
                                <div className="col-sm-6">
                                    <InputLabeled
                                        type="text"
                                        placeholder="Provincia"
                                        name="provincia"
                                        className="form-control"
                                        onChange={(evt)=>updateFormState("provincia", evt.target.value)}
                                        error = {getError("provincia")}
                                    />
                                </div>
                            </div>
                            <div className="form-group">
                                <textarea 
                                    className={"form-control " + (getError("comentario") ? "is-invalid": "")} 
                                    placeholder="Sus comentarios" 
                                    name="comentario" 
                                    onChange={(evt)=>updateFormState("comentario", evt.target.value)} rows="4" />
                            </div>
                            <AlertMensaje Estado={envioState} />
                            <div className="text-center mb-3">
                                <button disabled={!enviarEnabled()} type="button" onClick={()=>SendMail()} className="btn btn-lg btn-success"> ENVIAR <i className="fa fa-envelope-o" aria-hidden="true"></i> </button>
                            </div>
                            <div className="text-center mb-3">
                                <button type="button" onClick={()=>{history.push("/profesionales")}} className="btn btn-lg btn-primary"><i className="fa fa-arrow-left" aria-hidden="true"></i>  Volver </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AltaProfesionalesForm;
